export default "__VITE_ASSET__BPZVjEHu__"